import { eachDayOfInterval, addDays } from 'date-fns';
import { IAvailableBookingPeriod } from '@shared/integrations/taf-api/v2/models';

export const getDateRangesFromAvailableBookingPeriods = (periods: IAvailableBookingPeriod[]) => {
    const dates: Date[] = [];

    periods.forEach((x) => {
        if (x.startDate === undefined || x.startDate === null || x.endDate === undefined || x.endDate === null) return;
        const startDate = new Date(x.startDate);
        const endDate = addDays(new Date(x.endDate), -1);
        const interval = eachDayOfInterval({ start: startDate, end: endDate });
        dates.push(...interval);
    });

    return dates;
};

export function dateToLocalISOString(date: Date) {
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split('T')[0];
}

export function stringToLocalISOString(dateString: string) {
    const date = new Date(dateString);
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split('T')[0];
}

export function dateTimeStringToDate(dateString: string) {
    return dateString.split('T')[0];
}
